import React from "react";

export default function EmailMarketingComponent() {
  return (
    <div
      className="main_contact_area app pt-40 bg_fixed"
      
    >
      <div className="container">
        <div className="row align-items-center">
          {/* Left Side Image */}
          <div class="col-lg-7 pb-40">  
          <div className="section_main_title black text-left">
                <h5>Key Responsibilities</h5>
          </div> 

          <div class="choose-icon">
            <i class="fa fa-check check-icon"></i>
            <p class="choose-text text-left">
            Plan, design, and execute lead generation-focused email marketing campaigns that drive engagement and conversions.
            </p>
          </div>
          <div class="choose-icon">
            <i class="fa fa-check check-icon"></i>
            <p class="choose-text text-left">
           Develop and maintain visually engaging and responsive email templates, ensuring consistency with brand guidelines.
            </p>  
          </div>

          <div class="choose-icon">
            <i class="fa fa-check check-icon"></i>
            <p class="choose-text text-left">
           Develop and implement personalized email marketing campaigns that achieve
high open and click-through rates.
            </p>
          </div>

          <div class="choose-icon">
            <i class="fa fa-check check-icon"></i>
            <p class="choose-text text-left">
           Build, manage, and segment targeted contact lists to support personalized
campaign delivery.
            </p>
          </div>
          <div class="choose-icon">
            <i class="fa fa-check check-icon"></i>
            <p class="choose-text text-left">
           Monitor campaign performance; generate reports and analyse key metrics (CTR,
open rates, conversions) to measure effectiveness and inform future strategy.
            </p>
          </div>
          <div class="choose-icon">
            <i class="fa fa-check check-icon"></i>
            <p class="choose-text text-left">
           Manage email platforms (e.g., HubSpot, Mailchimp, Benchmark) and ensure high
deliverability, while maintaining compliance with CAN-SPAM, GDPR, and other
relevant regulations.
            </p>
          </div>
          <div class="choose-icon">
            <i class="fa fa-check check-icon"></i>
            <p class="choose-text text-left">
           Run A/B testing on subject lines, CTAs, content, and timing to optimize email
performance across segments.
            </p>
          </div>
          <div class="choose-icon">
            <i class="fa fa-check check-icon"></i>
            <p class="choose-text text-left">
           Collaborate with data and content teams to align email campaigns with overall
Account-Based Marketing (ABM) strategies.
            </p>
          </div>
          <div class="choose-icon">
            <i class="fa fa-check check-icon"></i>
            <p class="choose-text text-left">
           Contribute to the broader content strategy by developing ideas for supporting
blog posts, landing pages, or lead magnets tied to email campaigns.
            </p>
          </div>
          <div class="choose-icon">
            <i class="fa fa-check check-icon"></i>
            <p class="choose-text text-left">
           Apply SEO knowledge to enhance content relevance and discoverability.
            </p>
          </div>
             
            <div className="section_main_title black text-left mt-3">
                <h5>Sillset Required</h5>
            </div> 
             
            <div class="choose-icon">
            <i class="fa fa-check check-icon"></i>
            <p class="choose-text text-left">
           Proficient with email marketing platforms like Mailchimp, HubSpot, benchmark, or similar tools.
            </p>
            </div>

            <div class="choose-icon">
            <i class="fa fa-check check-icon"></i>
            <p class="choose-text text-left">
          Knowledge of SEO principles and how they can complement content strategies.
            </p>
            </div>
            <div class="choose-icon">
            <i class="fa fa-check check-icon"></i>
            <p class="choose-text text-left">
          Skilled in email content creation and template design, HTML/CSS, mobile-responsive
email templates.
            </p>
            </div>
            <div class="choose-icon">
            <i class="fa fa-check check-icon"></i>
            <p class="choose-text text-left">
          Strong project management skills and the ability to handle multiple campaigns
simultaneously.
            </p>
            </div>
            <div class="choose-icon">
            <i class="fa fa-check check-icon"></i>
            <p class="choose-text text-left">
          Excellent verbal and written communication and interpersonal skills.
            </p>
            </div>
            <div class="choose-icon">
            <i class="fa fa-check check-icon"></i>
            <p class="choose-text text-left">
          Strong grasp of email KPIs, list segmentation, conversion tracking, and campaign
analysis.
            </p>
            </div>
            <div class="choose-icon">
            <i class="fa fa-check check-icon"></i>
            <p class="choose-text text-left">
          Experience in ABM campaign management and optimization is must have.
            </p>
            </div>

            <div class="choose-icon">
            <i class="fa fa-check check-icon"></i>
            <p class="choose-text text-left">
          Comfortable working in a fast-paced, onsite environment, adapting and
collaborating across departments.
            </p>
            </div>
             
             
           
            
            
           
            
           
           
           
           
           
         
     
 
</div>


          {/* Right Side Contact Form */}
          <div className="col-lg-5">
            <div className="section_title black mb-4">
             
              <div className="section_main_title">
                <h1>Apply Now</h1>
              </div>
            </div>

            
            <iframe
              id="if15on87"
              src="https://formnx.com/f/career-15on87?iframe=true"
              frameBorder="0"
              style={{ width: '1px', minWidth: '100%', height: '800px' }}
              title="Career Form"
            />
            <script src="https://formnx.com/js/iframeResizer.js"></script>
            <script src="https://formnx.com/js/widget.js"></script>
          </div>
        </div>
      </div>
    </div>
  );
}
